import React from "react";
import "./AuthIconTooltip.scss";

type AuthIconTooltipProps = {
  label: string;
  children: React.ReactNode;
};

/** Custom tooltip, horizontally centered on the icon. */
export default function AuthIconTooltip({ label, children }: AuthIconTooltipProps) {
  const child = React.Children.only(children);
  const trigger =
    React.isValidElement(child)
      ? React.cloneElement(child, {
          ...(child.props as Record<string, unknown>),
          "aria-label": label,
        } as Record<string, unknown>)
      : children;

  return (
    <span className="auth-icon-tooltip">
      {trigger}
      <span className="auth-icon-tooltip__bubble" role="tooltip" aria-hidden="true">
        <span className="auth-icon-tooltip__inner">{label}</span>
      </span>
    </span>
  );
}
